<modal-panel title="Trip Information" (close)="close()">
  <ng-container>
    <trip-details [data]="data()"/>
  </ng-container>

  <ng-container modalPanelFooter>
    <button mat-raised-button color="primary" (click)="close()">
      Close
    </button>
  </ng-container>
</modal-panel>
